import { render, staticRenderFns } from "./ProductDetailVariant.vue?vue&type=template&id=5bd77f20"
import script from "./ProductDetailVariant.vue?vue&type=script&lang=js"
export * from "./ProductDetailVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports